// extracted by mini-css-extract-plugin
module.exports = {"container":"pcOr6NoR","dateSpan":"tWRNiPmT","styledPriceDisplay":"IGNY_FuL"};